<template>
	<div class="col-sm-12" v-show="!loading">
		<div class="box">
			<div class="box-body">

				<form class="form-horizontal form-history" @submit.prevent="search">
					<div class="form-group">
						<label for="inputSearch" class="col-sm-2 col-lg-2 search-label control-label">Search</label>
						<div class="col-sm-10 col-lg-8 search-field">
							<input type="text" class="form-control" v-model="searchTerm" id="inputSearch" placeholder="Keywords" autocomplete="off" />
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6 col-lg-4">
							<div class="form-group">
								<label class="col-sm-4 col-lg-4 control-label">Vintage</label>
								<div class="col-sm-8 col-lg-8">
									<select class="form-control" v-model="filters.vintage">
										<option value="" selected="selected" >All</option>
										<option v-for="vintage in vintageOptions" value="{{vintage.value}}">{{vintage.name}}</option>
									</select>
								</div>
							</div>
						</div>
						<div class="col-sm-6 col-lg-4">
							<div class="form-group">
								<label class="col-sm-4 col-lg-4 control-label">Varietal</label>
								<div class="col-sm-8 col-lg-8">
									<select class="form-control" v-model="filters.varietal_id">
										<option value="" selected="selected">All</option>
										<option v-for="varietal in varietalOptions" value="{{varietal.value}}">{{varietal.name}}</option>
									</select>
								</div>
							</div>
						</div>
						<div class="col-sm-6 col-lg-4">
							<div class="form-group">
								<label class="col-sm-4 col-lg-4 control-label">Yeast Type</label>
								<div class="col-sm-8 col-lg-8">
									<select class="form-control" v-model="filters.yeast_type_id">
										<option value="" selected="selected">All</option>
										<option v-for="yeastType in yeastTypeOptions" value="{{yeastType.value}}">{{yeastType.name}}</option>
									</select>
								</div>
							</div>
						</div>
						<div class="col-sm-6 col-lg-4">
							<div class="form-group">
								<label class="col-sm-4 col-lg-4 control-label">Fermenter</label>
								<div class="col-sm-8 col-lg-8">
									<select class="form-control" v-model="filters.fermenter_id">
										<option value="" selected="selected">All</option>
										<option v-for="fermenter in fermenterOptions" value="{{fermenter.value}}">{{fermenter.name}}</option>
									</select>
								</div>
							</div>
						</div>
						<div class="col-sm-6 col-lg-4">
							<div class="form-group">
								<label class="col-sm-4 col-lg-4 control-label">Performance</label>
								<div class="col-sm-8 col-lg-8">
									<select class="form-control" v-model="filters.performance">
										<option value="" selected="selected">All</option>
										<option v-for="performance in performanceOptions" value="{{performance.value}}">{{performance.name}}</option>
									</select>
								</div>
							</div>
						</div>
						<div class="col-sm-12 col-lg-4">
							<div class="col-lg-6 search-btn-container">
								<button type="reset" class="btn btn-block btn-info" @click.prevent="resetFilters">Clear Filters</button>
							</div>
							<div class="col-lg-6 search-btn-container">
								<button type="submit" class="btn btn-block btn-success" @click.prevent="search">Search</button>
							</div>
						</div>
					</div>

				</form>

				<hr />

				<table id="table-history-search" class="table table-bordered table-hover">
					<thead>
						<tr>
							<th data-priority="2">Fermenter</th>
							<th>Start Date</th>
							<th data-priority="3">Name</th>
							<th>Blend Code</th>
							<th>Batch Code</th>
							<th>Varietal</th>
							<th>Duration</th>
							<th>Performance</th>
							<th data-priority="1">View</th>
						</tr>
					</thead>
					<tfoot>
						<tr>
							<th>Fermenter</th>
							<th>Start Date</th>
							<th>Name</th>
							<th>Blend Code</th>
							<th>Batch Code</th>
							<th>Varietal</th>
							<th>Duration</th>
							<th>Performance</th>
							<th>View</th>
						</tr>
					</tfoot>
					<tbody>
						<tr v-for="ferment in filteredFerments">
							<td>{{ferment.fermenter.data.name}}</td>
							<td :data-sort="moment(ferment.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD')">{{ferment.start_date}}</td>
							<td>{{ferment.wine_name}}</td>
							<td>{{ferment.blend_code}}</td>
							<td>{{ferment.batch_code}}</td>
							<td>{{ferment.varietal}}</td>
							<td>{{ferment.duration}}</td>
							<td>
								{{ferment.gauge.data.status == 10 ? 'Low Range On Spec' : ''}}
								{{ferment.gauge.data.status == 20 ? 'High Range On Spec' : ''}}
								{{ferment.gauge.data.status == 30 ? 'Sluggish' : ''}}
								{{ferment.gauge.data.status == 40 ? 'Rapid' : ''}}
							</td>
							<td><a v-link="{name: 'ferments.index', params: { fermenterId: ferment.fermenter.data.id, fermentId:ferment.id }}" class="btn btn-sm btn-block btn-primary">View <i class="fa fa-arrow-right"></i></td>
						</tr>
					</tbody>
				</table>

				<hr />

				<a
					:href="Http.buildPath(`ferments/export-history?ferments=${this.fermentsToExport.join(',')}`)"
					class="btn btn-sm btn-success"
					:class="{'disabled': filteredFerments.length == 0 || eventLoading}">
					<!-- @click.pervent="exportHistory(fermentsToExport.join(','))"> -->
					<i class="fa fa-table"></i> Export To Excel
				</a>
			</div>
		</div>
	</div>
</template>

<script>
  import { site, varietals, yeastTypes, ferments, loading, fermenters, eventLoading } from 'vx/getters'
  import { Ferments as FermentActions, Settings as SettingActions, Fermenters as FermenterActions } from 'vx/actions'
  import Vue from 'vue'
  import moment from 'moment'
  import * as types from 'vx/mutation-types'
  import Http from 'utils/http'

	export default {

		components: {
		},

		vuex: {
			getters: {
				site,
				ferments,
				fermenters,
				loading,
				varietals,
				yeastTypes,
				eventLoading
			},

			actions: {
				allFerments: FermentActions.all,
				allFermenters: FermenterActions.all,
				exportHistory: FermenterActions.exportHistory,
				allVarietals: SettingActions.allVarietals,
				allYeastTypes: SettingActions.allYeastTypes,
			}
		},

		route: {
			canReuse: false,

			data() {
				this.$dispatch('loading');

				var that = this;
				this.allFerments(this.site.id, ['fermenter', 'gauge'], {archived: 1}).then(() => {
					if (this.ferments){
						this.ferments.forEach(ferment => {
							ferment.start_date = moment(ferment.start_date, 'DD/MM/YYYY hh:mm').format('DD/MM/YYYY');
							var year = moment(ferment.start_date, 'DD/MM/YYYY').year();
							var found = this.vintageOptions.some((option) => {
								return option.value === year;
							});
							if (!found) {

								this.vintageOptions.push({
									name: year,
									value: year,
								});
							}
							this.filteredFerments = this.ferments;
							this.fermentsToExport = this.filteredFerments.map(ferment => {
								return ferment.id;
							})
						})
					}

					this.loaded.push('ferments');
				});

				this.allVarietals().then(() => {
					this.varietalOptions = this.varietals.map(varietal => {
						return { name: varietal.name, value: varietal.id }
					});

					this.loaded.push('varietals');
				}) ;

				this.allYeastTypes().then(() => {
					this.yeastTypeOptions = this.yeastTypes.map(yeastType => {
						return { name: yeastType.name, value: yeastType.id }
					});

					this.loaded.push('yeast-types');
				});

				this.allFermenters(this.site.id).then(() => {
					this.fermenterOptions = this.fermenters.map(fermenter => {
						return { name: fermenter.name, value: fermenter.id}
					});

					this.loaded.push('fermenters');
				})
			}
		},

		data() {
			return {
				loaded: [],
				filters: {
					varietal_id: '',
					yeast_type_id: '',
					vintage: '',
					performance: '',
					fermenter_id: ''
				},
				varietalOptions: [],
				yeastTypeOptions: [],
				fermenterOptions: [],
				filteredFerments: [],
				vintageOptions: [],
				fermentsToExport: [],
				performanceOptions: [
				{
					name: 'Low Range On Spec',
					value: 10
				},
				{
					name: 'High Range on Spec',
					value: 20
				},
				{
					name: 'Sluggish',
					value: 30
				},
				{
					name: 'Rapid',
					value: 40
				}
				],
				searchTerm: '',
				Http,
				moment
			}
		},

		watch: {
			loaded() {
				if(this.loaded.length == 4){
					this.$dispatch('loaded');

					this.boot();
				}
			}
		},

		methods: {
			search() {
				if (! this.ferments) return;

				$('#table-history-search').dataTable().fnDestroy();

				this.filteredFerments = this.ferments.filter(ferment => {
					if (this.filters.varietal_id && this.filters.varietal_id != ferment.varietal_id) return false;

					if (this.filters.yeast_type_id && this.filters.yeast_type_id != ferment.yeast_type_id) return false;

					if (this.filters.fermenter_id && this.filters.fermenter_id != ferment.fermenter_id) return false;

					if (this.filters.vintage && this.filters.vintage != moment(ferment.start_date, 'DD/MM/YYYY hh:mm').year()) return false;

					if (this.filters.performance && this.filters.performance != ferment.gauge.data.status) return false;

					if (this.$options.filters.filterBy(ferment, this.searchTerm).length == 0) return false;

					return true;
				});

				this.fermentsToExport = this.filteredFerments.map(ferment => {
					return ferment.id;
				});

				this.boot();
			},

			resetFilters() {
				this.filters = {
					varietal_id: '',
					yeast_type_id: '',
					vintage: '',
					performance: '',
					fermenter_id: ''
				}

				this.searchTerm = '';

				this.search();
			},

			boot() {
				Vue.nextTick(() => {
					$('#table-history-search').dataTable({
						'bPaginate': true,
						'bLengthChange': false,
						'bFilter': false,
						'bSort': true,
						'bInfo': true,
						'bAutoWidth': false,
						'responsive': true,
						'language': {
							'emptyTable': 'No archived ferments.'
						}
					});
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// index.vue?40816ca0